import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "overview" }
const _hoisted_2 = { class: "ov-kpi-grid" }
const _hoisted_3 = { class: "ov-kpi-top" }
const _hoisted_4 = { class: "ov-kpi-icon" }
const _hoisted_5 = { class: "ov-kpi-value" }
const _hoisted_6 = {
  key: 0,
  class: "ov-skeleton ov-skeleton-lg"
}
const _hoisted_7 = { class: "ov-kpi-of" }
const _hoisted_8 = {
  key: 0,
  class: "ov-kpi-bar"
}
const _hoisted_9 = {
  key: 1,
  class: "ov-kpi-sub"
}
const _hoisted_10 = { class: "ov-kpi-top" }
const _hoisted_11 = { class: "ov-kpi-icon ov-kpi-icon-grey" }
const _hoisted_12 = { class: "ov-kpi-value" }
const _hoisted_13 = {
  key: 0,
  class: "ov-skeleton ov-skeleton-lg"
}
const _hoisted_14 = { class: "ov-kpi-of" }
const _hoisted_15 = {
  key: 0,
  class: "ov-kpi-bar"
}
const _hoisted_16 = {
  key: 1,
  class: "ov-kpi-sub"
}
const _hoisted_17 = { class: "ov-kpi-top" }
const _hoisted_18 = { class: "ov-kpi-icon ov-kpi-icon-super" }
const _hoisted_19 = { class: "ov-kpi-value" }
const _hoisted_20 = {
  key: 0,
  class: "ov-skeleton ov-skeleton-lg"
}
const _hoisted_21 = {
  key: 0,
  class: "ov-kpi-sub"
}
const _hoisted_22 = { class: "ov-kpi-top" }
const _hoisted_23 = { class: "ov-kpi-icon" }
const _hoisted_24 = { class: "ov-kpi-value" }
const _hoisted_25 = {
  key: 0,
  class: "ov-skeleton ov-skeleton-lg"
}
const _hoisted_26 = {
  key: 0,
  class: "ov-kpi-bar"
}
const _hoisted_27 = {
  key: 1,
  class: "ov-kpi-sub"
}
const _hoisted_28 = { class: "ov-kpi-top" }
const _hoisted_29 = { class: "ov-kpi-icon ov-kpi-icon-warn" }
const _hoisted_30 = { class: "ov-kpi-value" }
const _hoisted_31 = {
  key: 0,
  class: "ov-skeleton ov-skeleton-lg"
}
const _hoisted_32 = {
  key: 0,
  class: "ov-kpi-sub"
}
const _hoisted_33 = { class: "ov-kpi-top" }
const _hoisted_34 = { class: "ov-kpi-icon ov-kpi-icon-grey" }
const _hoisted_35 = { class: "ov-kpi-value" }
const _hoisted_36 = {
  key: 0,
  class: "ov-skeleton ov-skeleton-lg"
}
const _hoisted_37 = {
  key: 0,
  class: "ov-kpi-sub"
}
const _hoisted_38 = { class: "ov-columns" }
const _hoisted_39 = { class: "ov-panel" }
const _hoisted_40 = { class: "ov-panel-head" }
const _hoisted_41 = {
  key: 0,
  class: "ov-panel-count"
}
const _hoisted_42 = { class: "ov-panel-body" }
const _hoisted_43 = { class: "ov-mono" }
const _hoisted_44 = { class: "ov-list-main" }
const _hoisted_45 = { class: "ov-list-name" }
const _hoisted_46 = { class: "ov-list-meta" }
const _hoisted_47 = {
  key: 2,
  class: "ov-empty"
}
const _hoisted_48 = { class: "ov-panel" }
const _hoisted_49 = { class: "ov-panel-body" }
const _hoisted_50 = {
  key: 0,
  class: "ov-list-skel"
}
const _hoisted_51 = { class: "ov-coverage" }
const _hoisted_52 = { class: "ov-coverage-bar" }
const _hoisted_53 = { class: "ov-coverage-stats" }
const _hoisted_54 = { class: "ov-coverage-pct" }
const _hoisted_55 = { class: "ov-legend" }
const _hoisted_56 = { class: "ov-legend-item" }
const _hoisted_57 = { class: "ov-legend-item" }
const _hoisted_58 = { class: "ov-panel" }
const _hoisted_59 = { class: "ov-panel-head" }
const _hoisted_60 = {
  key: 0,
  class: "ov-panel-count"
}
const _hoisted_61 = { class: "ov-panel-body" }
const _hoisted_62 = { class: "ov-mono ov-mono-alt" }
const _hoisted_63 = { class: "ov-list-main" }
const _hoisted_64 = { class: "ov-list-name" }
const _hoisted_65 = { class: "ov-list-meta" }
const _hoisted_66 = {
  key: 0,
  class: "ov-badge ov-badge-super"
}
const _hoisted_67 = {
  key: 2,
  class: "ov-empty"
}
const _hoisted_68 = { class: "ov-columns ov-columns-2" }
const _hoisted_69 = { class: "ov-panel" }
const _hoisted_70 = { class: "ov-panel-body ov-donuts-body" }
const _hoisted_71 = { class: "ov-donut-pct" }
const _hoisted_72 = { class: "ov-donut-legend" }
const _hoisted_73 = { class: "ov-donut-title" }
const _hoisted_74 = { class: "ov-legend-item" }
const _hoisted_75 = { class: "ov-legend-item" }
const _hoisted_76 = { class: "ov-panel" }
const _hoisted_77 = { class: "ov-panel-head" }
const _hoisted_78 = {
  key: 0,
  class: "ov-panel-count"
}
const _hoisted_79 = { class: "ov-panel-body" }
const _hoisted_80 = {
  key: 2,
  class: "ov-empty ov-empty-ok"
}
const _hoisted_81 = { class: "ov-panel ov-log-panel" }
const _hoisted_82 = { class: "ov-panel-head" }
const _hoisted_83 = { class: "ov-modules-head-right" }
const _hoisted_84 = {
  key: 0,
  class: "ov-modules-summary"
}
const _hoisted_85 = ["disabled"]
const _hoisted_86 = { class: "ov-panel-body ov-modules-body" }
const _hoisted_87 = { class: "ov-mod-label" }
const _hoisted_88 = {
  key: 0,
  class: "ov-mod-skel"
}
const _hoisted_89 = {
  key: 1,
  class: "ov-mod-time"
}
const _hoisted_90 = {
  key: 2,
  class: "ov-mod-down-text"
}
const _hoisted_91 = { class: "ov-note" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["ov-kpi-card ov-kpi-primary", { 'ov-kpi-loading': _ctx.loading }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-domain", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ov-kpi-label" }, "Firme active", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.firmeActive), 1),
                _createElementVNode("span", _hoisted_7, "/ " + _toDisplayString(_ctx.firmeTotal), 1)
              ], 64))
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "ov-kpi-bar-fill",
                style: _normalizeStyle({ width: _ctx.firmePct + '%' })
              }, null, 4)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.firmePct) + "% din firmele configurate", 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["ov-kpi-card", { 'ov-kpi-loading': _ctx.loading }])
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-account-box-multiple-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ov-kpi-label" }, "Conturi active", -1))
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.accountsActive), 1),
                _createElementVNode("span", _hoisted_14, "/ " + _toDisplayString(_ctx.accountsTotal), 1)
              ], 64))
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", {
                class: "ov-kpi-bar-fill ov-kpi-bar-grey",
                style: _normalizeStyle({ width: _ctx.accountsActivePct + '%' })
              }, null, 4)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.accountsInactive) + " dezactivate", 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["ov-kpi-card", { 'ov-kpi-loading': _ctx.loading }])
      }, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-shield-crown-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ov-kpi-label" }, "Super administratori", -1))
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.superAdmins), 1)
              ], 64))
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "din " + _toDisplayString(_ctx.accountsTotal) + " conturi aplicație", 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["ov-kpi-card", { 'ov-kpi-loading': _ctx.loading }])
      }, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("mdi-account-group", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ov-kpi-label" }, "Acoperire conturi AD", -1))
        ]),
        _createElementVNode("div", _hoisted_24, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.coveragePct), 1),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ov-kpi-of" }, "%", -1))
              ], 64))
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", {
                class: "ov-kpi-bar-fill",
                style: _normalizeStyle({ width: _ctx.coveragePct + '%' })
              }, null, 4)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.usersCuCont) + " din " + _toDisplayString(_ctx.usersTotal) + " utilizatori AD au cont", 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["ov-kpi-card", { 'ov-kpi-loading': _ctx.loading }])
      }, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("span", _hoisted_29, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("mdi-account-alert-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "ov-kpi-label" }, "Conturi fără AD", -1))
        ]),
        _createElementVNode("div", _hoisted_30, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_31))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.accountsWithoutAD.length), 1)
              ], 64))
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_32, "necesită legare la Active Directory"))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["ov-kpi-card", { 'ov-kpi-loading': _ctx.loading }])
      }, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("span", _hoisted_34, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("mdi-account-check-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "ov-kpi-label" }, "Utilizatori AD activi", -1))
        ]),
        _createElementVNode("div", _hoisted_35, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_36))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.usersTotal), 1)
              ], 64))
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.usersFaraCont) + " fără cont creat în aplicație", 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "ov-panel-title" }, "Firme", -1)),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.companies.length), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_42, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "ov-list-skel"
                })
              }), 64))
            : (_ctx.companies.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.companies, (c) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: c.ID,
                    class: "ov-list-row"
                  }, [
                    _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.initials(c.Name)), 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("span", _hoisted_45, _toDisplayString(c.Name), 1),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(c.Source || "—"), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ov-badge", c.Active ? 'ov-badge-ok' : 'ov-badge-off'])
                    }, _toDisplayString(c.Active ? "Activă" : "Inactivă"), 3)
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_47, "Nu există firme configurate."))
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "ov-panel-head" }, [
          _createElementVNode("span", { class: "ov-panel-title" }, "Acoperire conturi AD")
        ], -1)),
        _createElementVNode("div", _hoisted_49, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", {
                      class: "ov-coverage-fill",
                      style: _normalizeStyle({ width: _ctx.coveragePct + '%' })
                    }, null, 4)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.coveragePct) + "%", 1),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ov-coverage-label" }, "din utilizatorii AD au cont creat în aplicație", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ov-dot ov-dot-red" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.usersCuCont) + " cu cont", 1)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ov-dot ov-dot-grey" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.usersFaraCont) + " fără cont", 1)
                  ])
                ])
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "ov-panel-title" }, "Conturi fără legătură AD", -1)),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.accountsWithoutAD.length), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_61, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "ov-list-skel"
                })
              }), 64))
            : (_ctx.accountsWithoutAD.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.accountsWithoutAD, (a) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: a.ID,
                    class: "ov-list-row"
                  }, [
                    _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.initials(a.Username)), 1),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("span", _hoisted_64, _toDisplayString(a.Username), 1),
                      _createElementVNode("span", _hoisted_65, _toDisplayString(a.Email || "—"), 1)
                    ]),
                    (a.SuperAdmin)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_66, "Super admin"))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ov-badge", a.Active ? 'ov-badge-ok' : 'ov-badge-off'])
                    }, _toDisplayString(a.Active ? "Activ" : "Inactiv"), 3)
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_67, "Toate conturile sunt legate de un cont AD."))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_68, [
      _createElementVNode("div", _hoisted_69, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "ov-panel-head" }, [
          _createElementVNode("span", { class: "ov-panel-title" }, "Distribuții")
        ], -1)),
        _createElementVNode("div", _hoisted_70, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "ov-donut-skel"
                })
              }), 64))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.donuts, (d) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: d.key,
                  class: "ov-donut-block"
                }, [
                  _createElementVNode("div", {
                    class: "ov-donut",
                    style: _normalizeStyle({ background: d.gradient })
                  }, [
                    _createElementVNode("span", _hoisted_71, _toDisplayString(d.pct) + "%", 1)
                  ], 4),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("span", _hoisted_73, _toDisplayString(d.title), 1),
                    _createElementVNode("div", _hoisted_74, [
                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "ov-dot ov-dot-red" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(d.value1) + " " + _toDisplayString(d.label1), 1)
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "ov-dot ov-dot-grey" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(d.value2) + " " + _toDisplayString(d.label2), 1)
                    ])
                  ])
                ]))
              }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_76, [
        _createElementVNode("div", _hoisted_77, [
          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "ov-panel-title" }, "Atenționări", -1)),
          (!_ctx.loading && _ctx.alerts.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(_ctx.alerts.length), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_79, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "ov-list-skel"
                })
              }), 64))
            : (_ctx.alerts.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.alerts, (a, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: _normalizeClass(["ov-alert-row", 'ov-alert-' + a.tone])
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(a.icon), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("span", null, _toDisplayString(a.text), 1)
                  ], 2))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    color: "#059669"
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode("mdi-check-circle-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[25] || (_cache[25] = _createElementVNode("span", null, "Nimic de semnalat.", -1))
                ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_81, [
      _createElementVNode("div", _hoisted_82, [
        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "ov-panel-title" }, "Stare module", -1)),
        _createElementVNode("div", _hoisted_83, [
          (!_ctx.modulesChecking)
            ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_ctx.modulesUpCount) + "/" + _toDisplayString(_ctx.modules.length) + " module online", 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "ov-refresh-btn",
            type: "button",
            disabled: _ctx.modulesChecking,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkAllModules && _ctx.checkAllModules(...args)))
          }, [
            _createVNode(_component_v_icon, { size: "15" }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createTextVNode("mdi-refresh", -1)
              ]))]),
              _: 1
            }),
            _cache[27] || (_cache[27] = _createElementVNode("span", null, "Reîmprospătează", -1))
          ], 8, _hoisted_85)
        ])
      ]),
      _createElementVNode("div", _hoisted_86, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (m) => {
          return (_openBlock(), _createElementBlock("div", {
            key: m.name,
            class: "ov-module-row"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["ov-mod-dot", {
              'ov-mod-dot-up': m.status === 'up',
              'ov-mod-dot-down': m.status === 'down',
              'ov-mod-dot-checking': m.status === 'checking',
            }])
            }, null, 2),
            _createElementVNode("span", _hoisted_87, _toDisplayString(m.label), 1),
            (m.status === 'checking')
              ? (_openBlock(), _createElementBlock("span", _hoisted_88))
              : (m.status === 'up')
                ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(m.responseTimeMs) + " ms", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_90, "indisponibil"))
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_91, [
      _createVNode(_component_v_icon, { size: "14" }, {
        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
          _createTextVNode("mdi-information-outline", -1)
        ]))]),
        _: 1
      }),
      _cache[30] || (_cache[30] = _createElementVNode("span", null, "Datele despre utilizatori vin din Active Directory (utilizatori activi, cu login în ultimele 3 luni).", -1))
    ])
  ]))
}